export default "/assets/images/cc-filter-room-01.dd7fd9265503f001.webp";